<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="$can('admin.languages.add')">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newLanguage()">
                      <i class="mdi mdi-plus mr-1"></i> Novo Idioma
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="5%">Ordem</th>
                    <th width="10%">Bandeira</th>
                    <th width="15%">Código</th>
                    <th width="25%">Nome</th>
                    <th width="25%">Nome Nativo</th>
                    <th width="10%">Status</th>
                    <th width="10%">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in languages" :key="item.id" class="link">
                    <td>{{ item.sort_order }}</td>
                    <td style="font-size: 24px;">{{ item.flag }}</td>
                    <td @click="$can('admin.languages.edit') ? editLanguage(item.id) : null">
                      {{ item.code }}
                      <span v-if="item.is_default" class="badge badge-primary ml-2">Padrão</span>
                    </td>
                    <td @click="$can('admin.languages.edit') ? editLanguage(item.id) : null">{{ item.name }}</td>
                    <td @click="$can('admin.languages.edit') ? editLanguage(item.id) : null">{{ item.native_name }}</td>
                    <td>
                      <span v-if="item.is_active" class="badge badge-success">Ativo</span>
                      <span v-else class="badge badge-secondary">Inativo</span>
                    </td>
                    <td>
                      <button
                        v-if="$can('admin.languages.edit') && !item.is_default"
                        class="btn btn-sm btn-outline-primary mr-1"
                        @click="makeDefault(item.id)"
                        title="Definir como padrão">
                        <i class="fas fa-star"></i>
                      </button>
                      <button
                        v-if="$can('admin.languages.edit')"
                        class="btn btn-sm btn-outline-secondary mr-1"
                        @click="toggleStatus(item.id)"
                        :title="item.is_active ? 'Desativar' : 'Ativar'">
                        <i :class="item.is_active ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
                      </button>
                      <button
                        v-if="$can('admin.translations.list')"
                        class="btn btn-sm btn-outline-info mr-1"
                        @click="goToTranslations(item.id)"
                        title="Gerenciar traduções">
                        <i class="fas fa-language"></i>
                      </button>
                      <button
                        v-if="!item.is_default && $can('admin.languages.delete')"
                        class="btn btn-sm btn-outline-danger"
                        @click="deleteLanguage(item.id)"
                        title="Excluir">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" :idLanguage="idLanguage" ref="formLanguage" @created="updateList"></modal-form>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import permissionMixin from '@/mixins/permissionMixin'

export default {
  mixins: [permissionMixin],
  components: {
    Layout,
    PageHeader,
    ModalForm
  },
  name: 'languages',
  page: {
    title: 'Idiomas',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      timeout: null,
      modalForm: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      idLanguage: null,
      perPage: 20,
      submitted: false,
      title: 'Gerenciamento de Idiomas',
      items: [{
        text: 'Administração'
      },
      {
        text: 'Idiomas',
        active: true
      }]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapState('language', ['languages', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('language', {
      getAll: 'getAll',
      deleteItem: 'deleteLanguage',
      toggleStatusAction: 'toggleStatus',
      setDefaultAction: 'setDefault'
    }),
    newLanguage () {
      this.$refs.formLanguage.open('')
      this.modalForm = true
    },
    editLanguage (id) {
      this.$refs.formLanguage.open(id)
      this.modalForm = true
      this.idLanguage = id
    },
    goToTranslations (languageId) {
      this.$router.push({ name: 'translations', query: { language_id: languageId } })
    },
    toggleStatus (id) {
      this.toggleStatusAction(id).then(() => {
        successMessage('Status alterado com sucesso.', 2500)
        this.updateList()
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
      })
    },
    makeDefault (id) {
      Swal.fire({
        title: 'Definir como padrão?',
        text: 'Este idioma será definido como o idioma padrão do sistema.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DEFINIR!'
      }).then(result => {
        if (result.value) {
          this.setDefaultAction(id).then(() => {
            successMessage('Idioma padrão atualizado com sucesso.', 2500)
            this.updateList()
          }).catch((err) => {
            errorMessage('Alerta: ' + err.message)
          })
        }
      })
    },
    deleteLanguage (id) {
      Swal.fire({
        title: 'Você tem certeza?',
        text: 'Essa ação não poderá ser revertida. Todas as traduções deste idioma também serão excluídas.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.deleteItem(id).then(() => {
              successMessage('Sucesso: Idioma excluído com sucesso.', 2500)
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px; }
.float-sm-end { float: right }
</style>
